import {
  FormControl,
  FormHelperText,
  OutlinedInput as MuiOutlinedInput,
} from '@mui/material';
import { useController, useFormContext } from 'react-hook-form';

import { useLetterCounter } from 'shared/components/form/hooks/useLetterCounter';

import type { OutlinedInputProps as MuiOutlinedInputProps } from '@mui/material';
import type { FC } from 'react';
import type { MaxLetterCount } from 'shared/components/form/types';

interface OutlinedInputProps extends Omit<MuiOutlinedInputProps, 'name'> {
  name: string;
}

interface FormOutlinedInputProps extends OutlinedInputProps {
  maxLetterCount?: MaxLetterCount;
}

export const FormOutlinedInput: FC<FormOutlinedInputProps> = ({
  name,
  maxLetterCount,
  ref,
  ...props
}) => {
  const letterCount = useLetterCounter(name, maxLetterCount);
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({ control, name });

  return (
    <FormControl fullWidth error={!!error} disabled={props.disabled}>
      <MuiOutlinedInput fullWidth multiline {...field} ref={ref} {...props} />
      <FormHelperText>{error ? error.message : letterCount}</FormHelperText>
    </FormControl>
  );
};
